"use client";

import { useRef } from "react";

import styles from "./FloatingProduct.module.css";
import type { BlokRouter } from "@/data/routes/bloks.route";
import { Checkout24 } from "@/components/icons/Checkout";
import { Link } from "@/i18n/Link";
import { useGlobal } from "@/features/global/GlobalContext";
import { formatPrice } from "@/lib/utils";
import { clsx } from "@frend-digital/ui";

interface FloatingProductProps {
	product?: BlokRouter["taggedImage"]["desktop"][number];
	color?: string | number | undefined;
}

export const FloatingProduct = ({ product, color }: FloatingProductProps) => {
	const ref = useRef<HTMLDivElement>(null!);

	if (!product) return null;

	const {
		data: { colorMap },
	} = useGlobal();

	const colorEntry = colorMap[color || ""] || "";
	return (
		<div
			className={styles.tag}
			style={{
				left: `${product.tag?.x ?? "0"}%`,
				top: `${product.tag?.y ?? "0"}%`,
			}}
			ref={ref}
		>
			<div
				className={styles.cartTag}
				style={{ background: colorEntry.color, color: colorEntry.foreground }}
			>
				<Checkout24 />
			</div>
			<Link
				href={`/${product.product.canonicalUri}`}
				className={clsx(styles.trigger, colorEntry.foreground === "#ffffff" && styles.textShadow)}
				style={{ color: colorEntry.foreground }}
			>
				<span className={styles.name}>{product.product.name}</span>
				<span className={styles.price}>{formatPrice(product.product.price)}</span>
			</Link>
		</div>
	);
};
